<template>
<div :class="boxdrawerclass">
    <img
      v-show="!loaded"
      alt="Sample image boxgenerator"
      src="../assets/boxgenerator_sample1.jpg"
      class="responsive img-responsive img-default-box"
    />
    <img v-show="loaded" :src="image" alt="BoxImage" class="responsive img-responsive img-default-box" />
    <div @click="openBoxSelector" v-show="!buttonishidden" class="boxdrawer-change-button" title="Vaihda laatikon malli">Vaihda malli</div>
</div>
</template>

<script>
export default {
    name: "BoxDrawer",
    props: {
        msg: String,
    },
    computed: {
        imageData: function () {
            if(this.image != null) {
                //this.loaded = true;
                return this.image;
            }
            return "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
        },
        boxdrawerclass: function() {
            if(this.$parent.showForm) {
                return "boxdrawer form-opened";
            }
            else return "boxdrawer"
        }
    },
    mounted() {
        var vmm=this;
        this.$parent.$on('imageUpdate', data => {
               this.image = data;
        });
        this.$parent.$on('imageError', function() {
               console.log('@@TODO load bas64 error image data here');
               vmm.image = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

        });
        setTimeout(function() {
            vmm.loaded = true;
        }, 100);
    },
    methods: {
        openBoxSelector() {
            this.$emit('openboxselector');
        },
        hideButton() {
            this.buttonishidden = true;
        },
        showButton() {
            this.buttonishidden = false;
        }

    },
    data() {
        return {
            loaded:false,
            buttonishidden: false,
            image: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.boxdrawer {
    display: grid;
    place-items: center;
    position: relative;
}
@media only screen and (min-width: 320px) and (max-width: 800px) {
    .boxdrawer.form-opened {
        width: 60%;
        margin: auto;
        -webkit-animation: formOpened 0.1s ease-in;
    }
}
@keyframes formOpened {
    0% { width: 100%; }
    100% { width: 60%; }
}
@-webkit-keyframes formOpened {
    0% { width: 100%; }
    100% { width: 60%; }
}
@keyframes cssAnimation {
    0% { opacity: 1; }
    100% { opacity: 0.2; }
}
@-webkit-keyframes cssAnimation {
    0% { opacity: 1; }
    100% { opacity: 0.2; }
}

.boxdrawer-change-button {
    background: url('data:image/png;base64,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');
    background-size: 40px 40px;
    background-color: rgba(255, 255, 255, 0.3);
    display: block;
    clear: none;
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 140px;
    height: 40px;
    z-index: 10;
    cursor: pointer;
    z-index: 300;
    background-repeat: no-repeat;
    background-position: center right;
    text-align: left;
    font-size: 17px;
    font-weight: bold;
    line-height: 45px;
    -webkit-animation: cssAnimation 0.3s ease-in 5s forwards;
    animation: cssAnimation 0.3s ease-in 5s forwards;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    &:hover {
        animation: cssAnimation 0.3s ease-in 0.3s reverse;
        /*opacity: 1;*/
    }
}

</style>